import { clsx } from 'clsx';
import React from 'react';

import { SvgIconProps } from './SvgIcon';

const AiIcon = (props: SvgIconProps) => (
  <svg
    viewBox="-100 -100 200 200"
    height={props.size}
    width={props.size}
    className={clsx('tw-relative', props.offsetUp ? '-tw-top-[0.08em]' : null, props.className)}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="
      M 0 100
      A 100 100 0 0 1 100 0
      A 100 100 0 0 1 0 -100
      A 100 100 0 0 1 -100 0
      A 100 100 0 0 1 0 100
      Z
    "
      fill="currentColor"
    />
  </svg>
);

export default AiIcon;
